export const truncateItemName = (name: string, maxLength = 30): string => {
  if (name.length < maxLength) {
    return name;
  }

  return `${name.slice(0, maxLength - 3)}...`;
};
